var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatsBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_911_426",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22V22H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_911_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.979 17.5725C14.5466 18.6594 12.7981 19.2481 10.9999 19.2491C9.68368 19.2511 8.38623 18.9367 7.21686 18.3325L2.74994 19.2491L3.6666 14.7822C2.84261 13.184 2.56364 11.3603 2.87219 9.58883C3.18075 7.81738 4.05991 6.19536 5.37574 4.96987C6.69157 3.74439 8.37193 2.98263 10.1608 2.80065C11.9497 2.61867 13.749 3.02644 15.2847 3.96185C16.8203 4.89725 18.0081 6.30901 18.6671 7.98203C19.326 9.65505 19.42 11.4976 18.9348 13.229C18.4495 14.9604 17.4115 16.4857 15.979 17.5725Z",
    stroke: "#303030",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 12.4476 3.3845 13.8054 4.05694 14.9769L3 18.5L7.32337 18.107C8.42419 18.6776 9.67445 19 11 19Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsBold);
export default __webpack_public_path__ + "static/media/chats-bold.f7ebe309a03d0576135d6be7806ffd59.svg";
export { ForwardRef as ReactComponent };